import { createContext, useContext, type ReactNode } from "react"
import {
  useRegistrationAccessStore,
  type RegistrationAccessStoreValue
} from "./useRegistrationAccessStore"

const RegistrationAccessContext = createContext<
  RegistrationAccessStoreValue | undefined
>(undefined)

/** Mount once in the session shell to share the query, pagination, and freshness. */
export function RegistrationAccessProvider({
  children
}: {
  children: ReactNode
}) {
  const value = useRegistrationAccessStore()
  return (
    <RegistrationAccessContext.Provider value={value}>
      {children}
    </RegistrationAccessContext.Provider>
  )
}

export function useRegistrationAccesses(): RegistrationAccessStoreValue {
  const value = useContext(RegistrationAccessContext)
  if (!value)
    throw new Error(
      "useRegistrationAccesses requires RegistrationAccessProvider."
    )
  return value
}
